import React from 'react';

// Flux
import { useAppSelector } from '../../flux/configureStore';

// Constellation
import { Button, Heading, ModalDialog, TextButton } from '@zillow/constellation';

// Misc / Utils
import * as S from './styles';
import { augmentError, formatForLog } from '../../utils/errors';
import { logger } from '../../index';

// Components
import ActiveRentals from '../ActiveRentals';
import Amenities from '../Amenities';
import Bedrooms from '../Bedrooms';
import Distance from '../Distance';
import OffMarket from '../OffMarket';
import PropertyType from '../PropertyType';

// Types
import type { PartialFilterType } from '../../models/Types';

interface FilterModalProps {
  close: () => void;
  setIsLoading: (isLoading: boolean) => void;
}

const FilterModal = ({ close, setIsLoading, ...rest }: FilterModalProps) => {
  const setFilter = useAppSelector((state) => state.setFilter);
  const onFilterChange = async (partialFilterObj?: PartialFilterType) => {
    setIsLoading(true);
    try {
      await setFilter(partialFilterObj);
    } catch (err: any) {
      augmentError(err, {
        root: 'modules/FilterModal#onFilterChange',
      });

      logger.error(formatForLog(err), 'Filter: Error handling filter change in mobile modal');
    }
    setIsLoading(false);
  };
  const handleResetFilters = async () => {
    setIsLoading(true);
    try {
      await setFilter();
    } catch (err) {
      augmentError(err, {
        root: 'filters/FilterModal#handleResetFilters',
      });

      logger.error(formatForLog(err), 'Filter: Error handling filter reset in mobile modal');
    }
    setIsLoading(false);
  };
  return (
    <ModalDialog
      {...rest}
      mediaQuery={{ xs: { fullScreen: true }, lg: { fullScreen: false } }}
      header={
        <S.HeadingContainer>
          <S.ResetContainer>
            <TextButton onClick={handleResetFilters}>Reset all</TextButton>
          </S.ResetContainer>
          <Heading level={6}>All filters</Heading>
        </S.HeadingContainer>
      }
      body={
        <S.Container>
          <ActiveRentals onFilterChange={onFilterChange} />
          <OffMarket onFilterChange={onFilterChange} />
          <Bedrooms onFilterChange={onFilterChange} />
          <PropertyType onFilterChange={onFilterChange} />
          <Distance onFilterChange={onFilterChange} />
          <Amenities onFilterChange={onFilterChange} />
        </S.Container>
      }
      footer={
        <S.DoneContainer>
          <Button buttonType="secondary" onClick={close}>
            Done
          </Button>
        </S.DoneContainer>
      }
    />
  );
};

export default FilterModal;
